import React, { FC } from 'react';
import styles from './styles.module.css';

export const Loading: FC = () => {
  return <div className={styles.animation} data-testid="loading-animation" />;
};

type LoadingPageProps = {
  message?: string;
};

export const LoadingPage: FC<LoadingPageProps> = ({ message }) => {
  return (
    <div className={styles.page} data-testid="loading-page">
      <div className={styles.animationWrapper}>
        <Loading />
        {message && <div className={styles.message}>{message}</div>}
      </div>
    </div>
  );
};
